module.exports = __webpack_public_path__ + "img/公司架构@2x.e7501918.png";